import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Typography, Divider } from "@mui/material";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function FrequentlyAskedFreeByCode() {
  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Divider>سوالات متداول</Divider>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>کد رایگان را از کجا دریافت کنم؟</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            هدف از انتشار این نسخه از برنامه{" "}
            <strong>ارائه یک نسخه رایگان </strong> جهت معرفی برنامه و برآورد
            نیاز کاربران برای ساخت ورژن نهایی برای ویندوز ، موبایل و TV می باشد.
          </Typography>
          <Typography>
            اما پس از انتشار، با <strong>مسئله معرفی برنامه </strong> به کاربران
            مواجه شدیم و متاسفانه بدون تبلیغات ادامه کار امکان پذیر نبود و در
            نتیجه برای اینکه <strong> همچنان برنامه رایگان </strong> ارائه گردد
            راهکار استفاده رایگان از برنامه در ازای معرفی آن را در پیش گرفتیم:
          </Typography>
          <Typography>راه های استفاده رایگان از اپلیکشین:</Typography>
          <Typography sx={{ backgroundColor: "#14ff27", color: "#0004ff" }}>
            روش اول: کد دریافت رایگان:
          </Typography>
          <Typography sx={{ backgroundColor: "#14ff27", color: "#0004ff" }}>
            به پیجهای اینستاگرام که فالوور زیادی دارند کدی اهدا میگردد که می
            توانند این کد را با فالوورهای خود به اشتراک گذاشته و آنها از طریق
            این کد بصورت رایگان اشتراک برنامه را دریافت دریافت میکنند.
          </Typography>
          <Typography>
            شما اگر خود پیجی در ایسنتاگرام ندارید می توانید در بخش کامنت ها و
            دایرکت پیج های مختلف با منشن (umlang_com) از آنها درخواست کد رایگان
            نمایید و این پیج ها کافیه به ما در اینستاگرام دایرکت دهند و کد را
            دریافت کنند.
          </Typography>
          <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
            آدرس پیج ایسنتاگرام : umlang_com
          </Typography>
          <Typography sx={{ backgroundColor: "#14ff27", color: "#0004ff" }}>
            روش دوم: استفاده از کد معرف دوستان
          </Typography>
          <Typography sx={{ backgroundColor: "#14ff27", color: "#0004ff" }}>
            اگر شما خودتان پیج اینستاگرام با فالوور زیاد ندارید، می توانید
            خودتان کد معرفی بسازید و با چند نفر از دوستان خود به اشتراک بگذارید
            و از برنامه بصورت رایگان استفاده کنید.
          </Typography>
          <Typography>
            استفاده از روش دوم فقط در اپلیکشین موبایل برنامه امکان پذیر است،
            البته پس از دریافت اشتراک رایگان در هر دو محیط کامپیوتر(web App) و
            اپلیکشین موبایل کاربری شما تبدیل به ویژه خواهد شد.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>
            تفاوت اشتراک رایگان با اشتراک پولی در چیست؟؟
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
           هیچ تفاوتی در اشتراک ها وجود ندارد.
          </Typography>
          <Typography>
            در پاسخ به پرسش بعدی توضیحات بیشتر نوشته شده است
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>
            با وجود گزینه رایگان ، دلیل وجود پکیج های اشتراکی چیست؟
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            همانطور که در بالا گفته شد هیچ تفاوتی از لحاظ دسترسی در اشتراک رایگان و اشتراک پولی وجود ندارند
          </Typography>
          <Typography>
            هزینه دریافت شده از طریق پکیج پولی بصورت کامل هزینه سایت ، برنامه و
            تبلیغات برنامه می شود.
          </Typography>
          <Typography>
            در حالت رایگان افراد مختلف وظیفه معرفی برنامه را رایگان انجام می
            دهند و به پاس این عمل اوملنگ نیز به کسانی که ازاین طریق وارد برنامه
            شده اند اشتراک رایگان اهدا خواهد کرد.
          </Typography>
          <Typography sx={{ backgroundColor: "#14ff27", color: "#0004ff" }}>
            هدف ما از انشتار این نسخه برنامه ارائه یک برنامه رایگان بود ، اما به
            منظور تامین هزینه های برنامه و معرفی به زبان آموزان هر دو روش اشتراک
            رایگان و پولی ایجاد شده است.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
